import {memo} from 'react';

import styled, {css} from 'styled-components';

import PieButton from '~/shared/theme/pie/PieButton';
import {FlexCenter, FlexColumn} from '~/shared/theme/FlexLayout';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {bodyRegular, headingS} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';

import errorImageUrl from './errorTriangle.png';

const Root = styled(FlexColumn)`
  padding: 32px 32px 24px 32px;
`;

const Content = styled(FlexCenter)`
  flex-direction: column;
  gap: 24px;
  padding-bottom: 32px;
`;

const TextsContainer = styled(FlexColumn)`
  gap: 8px;
`;

const textsStyle = css`
  text-align: center;
  width: 100%;
`;

const Title = styled.p`
  ${textsStyle}
  ${headingS}
`;

const Body = styled.p`
  ${textsStyle}
  ${bodyRegular}
`;

const StyledPieButton = styled(PieButton)`
  width: 100%;
`;

const ErrorImage = styled(ImageWithAlt).attrs({src: errorImageUrl, alt: 'error-img'})`
  width: 200px;
  height: 200px;
`;

type ModalErrorViewProps = {
  title: string;
  body: string;
  onClose?: () => void;
};

const ModalErrorView = ({onClose, title, body}: ModalErrorViewProps) => {
  const {t} = getLocalizationService();

  return (
    <Root>
      <Content>
        <ErrorImage />
        <TextsContainer>
          <Title>{title}</Title>
          <Body>{body}</Body>
        </TextsContainer>
      </Content>
      <StyledPieButton variant="primaryXL" onClick={onClose}>{t('close_credit_modal')}</StyledPieButton>
    </Root>
  );
};

export default memo(ModalErrorView);
